export default __webpack_public_path__ + "static/media/cardImg2.2d0a3dca.png";